import { makeStyles } from "@fluentui/react-components";
import { iconFilledClassName, iconRegularClassName } from "@fluentui/react-icons";
import React from "react";

export type IconButtonProps = {
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  icon: React.ReactNode;
  style?: React.CSSProperties;
};

export const IconButton: React.FC<IconButtonProps> = ({
  isSelected = false,
  disabled = false,
  onClick = () => {},
  icon,
  style,
}) => {
  const classes = useStyles();

  const className = isSelected ? classes.selected : classes.default;

  return (
    <button
      className={className}
      onClick={disabled ? undefined : onClick}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
        ...style,
      }}
      disabled={disabled}
      type="button"
    >
      {icon}
    </button>
  );
};

const useStyles = makeStyles({
  default: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    background: "transparent",
    border: "none",
    fontSize: "14px",
    ":hover": {
      [`& .${iconFilledClassName}`]: {
        display: "block",
      },
      [`& .${iconRegularClassName}`]: {
        display: "none",
      },
    },
  },
  selected: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    margin: 0,
    background: "transparent",
    border: "none",
    fontSize: "14px",
    [`& .${iconRegularClassName}`]: {
      display: "none",
    },
    [`& .${iconFilledClassName}`]: {
      display: "block",
    },
    ":hover": {
      [`& .${iconFilledClassName}`]: {
        display: "none",
      },
      [`& .${iconRegularClassName}`]: {
        display: "block",
      },
    },
  },
});
